export class GlobalConstants {
  public static readonly ROUTING = {
    LOGIN: 'login',
    DASHBOARD: 'dashboard',
    EXECUTION_LOGS: 'execution-logs',
    PAYMENT_INSTRUCTIONS: 'payment-instructions',
    BANKING_INFO: 'banking-info',
    EXPENSE_REPORT: 'expense-report',
    EXPENSES: 'expenses'
  }

  public static readonly CURRENCY_SYMBOL_MAPPING = {
    INR: '₹',
    JPY: '¥',
    MXN: '$'
  }

  public static readonly REJECTION_TYPE_OPTION_LIST = [
    {
      label: 'Invalid Account Details',
      value: 'INVALID_ACCOUNT_DETAILS'
    },
    {
      label: 'Invalid Bank Details',
      value: 'INVALID_BANK_DETAILS'
    },
    {
      label: 'Others',
      value: 'OTHERS'
    }
  ]
}

export enum Status {
  BANKING_INFO_NOT_AVAILABLE = 'BANKING_INFO_NOT_AVAILABLE',
  BANKING_INFO_UPDATED = 'BANKING_INFO_UPDATED',
  WRITE_OFF = 'WRITE_OFF',
  FUNDED = 'FUNDED',
  FUNDING_REQUESTED = 'FUNDING_REQUESTED',
  FUNDING_READY = 'FUNDING_READY',
  NEGATIVE_HOLD = 'NEGATIVE_HOLD',
  PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED',
  PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
  READY_FOR_REPROCESSING = 'READY_FOR_REPROCESSING',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  LTR_EXPENSE = 'LTR_EXPENSE',
}

export enum ProcessingStatus {
  RECEIVED = 'RECEIVED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  DELIVERED = 'DELIVERED'
}

export const STATUS_GROUPING: Record<string, {label: string, order: number, bg_color: string, text_color: string, filter: {}}> = {
  "ACTION_REQUIRED": {label: "ATTENTION REQUIRED", order: 3, bg_color: "#FFEB9C", text_color: "#9C6500", filter: {"status": "NEGATIVE_HOLD,BANKING_INFO_NOT_AVAILABLE"}},
  "AWAITING_CONFIRMATION": {label: "AWAITING COMPLETION", order: 1, bg_color: "#C6EFCE", text_color: "#006100", filter: {"status": "PAYMENT_PROCESSED"}},
  "IN_PROGRESS": {label: "IN PROGRESS", order: 2, "bg_color": "#D9EAFD", "text_color": "#0B5394", filter: {"status": "RECEIVED,BANKING_INFO_UPDATED,FUNDING_READY,FUNDING_PROCESSED,FUNDED,READY_FOR_REPROCESSING"}},
  "REJECTED": {label: "REJECTED/WRITE OFF", order: 4, bg_color: "#FFC7CE", text_color: "#9C0006", filter: {"status": "REJECTED,WRITE_OFF"}}
}

export interface ColorProfile {
  bg_color: string
  text_color: string
}

export enum PROFILE {
  BLUE,
  RED,
  GREEN,
  YELLOW
}

export const colorProfiles: Record<PROFILE, ColorProfile> = {
  [PROFILE.BLUE]: {
    bg_color: "#D9EAFD",
    text_color: "#0B5394"
  },
  [PROFILE.RED]: {
    bg_color: "#FFC7CE",
    text_color: "#9C0006"
  },
  [PROFILE.GREEN]: {
    bg_color: "#C6EFCE",
    text_color: "#006100"
  },
  [PROFILE.YELLOW]: {
    bg_color: "#FFEB9C",
    text_color: "#9C6500"
  }
}

export const STATUS_MAPPING: Record<Status, { label: string; profile: PROFILE; order: number }> = {
  [Status.BANKING_INFO_NOT_AVAILABLE]: { label: 'Banking Info Not Available', profile: PROFILE.YELLOW, order: 4 },
  [Status.BANKING_INFO_UPDATED]: { label: 'Banking Info Updated', profile: PROFILE.BLUE, order: 11 },
  [Status.WRITE_OFF]: { label: 'Write Off', profile: PROFILE.YELLOW, order: 13 },
  [Status.FUNDED]: { label: 'Funded', profile: PROFILE.BLUE, order: 7 },
  [Status.FUNDING_REQUESTED]: { label: 'Funding Requested', profile: PROFILE.BLUE, order: 6 },
  [Status.FUNDING_READY]: { label: 'Funding Ready', profile: PROFILE.BLUE, order: 5 },
  [Status.NEGATIVE_HOLD]: { label: 'Negative Hold', profile: PROFILE.YELLOW, order: 2 },
  [Status.PAYMENT_CONFIRMED]: { label: 'Payment Confirmed', profile: PROFILE.GREEN, order: 12 },
  [Status.PAYMENT_PROCESSED]: { label: 'Payment Processed', profile: PROFILE.GREEN, order: 8 },
  [Status.READY_FOR_REPROCESSING]: { label: 'Ready For Reprocessing', profile: PROFILE.BLUE, order: 10 },
  [Status.RECEIVED]: { label: 'Received', profile: PROFILE.BLUE, order: 1 },
  [Status.REJECTED]: { label: 'Rejected', profile: PROFILE.RED, order: 9 },
  [Status.LTR_EXPENSE]: { label: 'LTR Expense', profile: PROFILE.YELLOW, order: 3 },
};

export const PROCESSING_STATUS_MAPPING: Record<ProcessingStatus, { label: string; profile: PROFILE }> = {
  [ProcessingStatus.RECEIVED]: { label: 'Received', profile: PROFILE.BLUE },
  [ProcessingStatus.IN_PROGRESS]: { label: 'In Progress', profile: PROFILE.BLUE },
  [ProcessingStatus.COMPLETED]: { label: 'Completed', profile: PROFILE.GREEN },
  [ProcessingStatus.DELIVERED]: { label: 'Delivered', profile: PROFILE.GREEN },
}

export enum REJECTION_TYPE {
  INVALID_ACCOUNT_DETAILS = 'INVALID_ACCOUNT_DETAILS',
  INVALID_BANK_DETAILS = 'INVALID_BANK_DETAILS',
  OTHERS = 'OTHERS'
}

export const BANKING_INFO_LABEL_MAPPING: Record<string, { [key: string]: string }> = {
  "INDIA": {"attribute1": "Bank Name", "attribute2": "IFSC Code", "attribute3": "Bank / Branch Code"},
  "JAPAN": {"attribute3": "Bank ID", "attribute4": "Branch ID"},
  "MEXICO": {"attribute1": "Bank Name"},
}
